import { Redirect, Route, Switch } from 'react-router-dom';
import Content from 'assets/js/components/Content';
import { BankAccount } from 'assets/js/pages/payouts/BankAccount';
import { InstantPayoutNotification } from 'assets/js/pages/payouts/InstantPayoutNotification';
import { PayoutsHistory } from 'assets/js/pages/payouts/PayoutsHistory';
import { PayoutsRefreshButton } from 'assets/js/pages/payouts/PayoutsRefreshButton';
import { PayoutsSettings } from 'assets/js/pages/payouts/PayoutsSettings';
import { PayoutsSettingsAlert } from 'assets/js/pages/payouts/PayoutsSettingsAlert';
import { PayoutsTable } from 'assets/js/pages/payouts/PayoutsTable';
import { PayoutsTaxDocuments } from 'assets/js/pages/payouts/PayoutsTaxDocuments';
import { StripeNotificationsBanner } from 'assets/js/pages/payouts/StripeNotificationsBanner';
import { StripeNotificationsProvider } from 'assets/js/pages/payouts/StripeNotificationsContext';
import { useFetchPayoutAccount } from 'assets/js/pages/payouts/useFetchPayoutAccount';
import { Permissions } from 'components/permissions';
import { FinancePermission } from 'components/permissions/PermissionEnums';
import * as SubNav from 'components/sub-nav';
import { PayoutsSubNavTabs } from 'components/sub-nav/PayoutsSubNavTabs';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useFlags } from 'launchdarkly-react-client-sdk';

const Payouts = () => {
    const { payoutsRefresh } = useFlags();
    const { accountId } = useCurrentAccount();
    const { data: payoutAccount } = useFetchPayoutAccount();
    const payoutAccountData = payoutAccount.data;
    const isCustomAccount = payoutAccountData?.merchant_account_type === 'custom';

    return (
        <StripeNotificationsProvider>
            <Permissions
                allowed={[FinancePermission.PAYOUTS]}
                fallback={<Redirect to={`/accounts/${accountId}/home`} />}
            >
                <Content>
                    <div className={'flex flex-col gap-4'}>
                        {isCustomAccount && <StripeNotificationsBanner />}
                        <SubNav.Root>
                            <SubNav.Header>
                                <SubNav.Title>Payouts</SubNav.Title>
                                <SubNav.Actions>
                                    {payoutsRefresh && <PayoutsRefreshButton />}
                                </SubNav.Actions>
                            </SubNav.Header>
                            <BankAccount />
                            <PayoutsSettingsAlert />
                            <PayoutsSubNavTabs />
                            <InstantPayoutNotification />
                        </SubNav.Root>
                        <Switch>
                            <Route path="/accounts/:account_id/payouts" exact>
                                <PayoutsTable filter="all" />
                            </Route>
                            <Route path="/accounts/:account_id/payouts/balance" exact>
                                <PayoutsTable filter="has_balance" />
                            </Route>
                            <Route path="/accounts/:account_id/payouts/withdrawn" exact>
                                <PayoutsTable filter="withdrawn" />
                            </Route>
                            <Route
                                path="/accounts/:account_id/payouts/history"
                                component={PayoutsHistory}
                                exact
                            />
                            <Route
                                path="/accounts/:account_id/payouts/documents"
                                component={PayoutsTaxDocuments}
                                exact
                            />
                            <Route
                                path="/accounts/:account_id/payouts/settings"
                                component={PayoutsSettings}
                                exact
                            />
                        </Switch>
                    </div>
                </Content>
            </Permissions>
        </StripeNotificationsProvider>
    );
};

export { Payouts };
